module.exports = __webpack_public_path__ + "static/media/nando.ef02f98c.webp";